// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"spinner_spinnerContainer__yh9BG"};